import { render, staticRenderFns } from "./TitleMain.vue?vue&type=template&id=24645c80&scoped=true&"
import script from "./TitleMain.vue?vue&type=script&lang=js&"
export * from "./TitleMain.vue?vue&type=script&lang=js&"
import style0 from "./TitleMain.vue?vue&type=style&index=0&id=24645c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24645c80",
  null
  
)

export default component.exports